export default {
  apiUrl: '',
  jsApi: false,
  apiKey: false,
  mapboxAccessToken: process.env.VUE_APP_MAPBOX_ACCESS_TOKEN
};
